import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const BugsTrackerRepository = RepositoryFactory.get("bugs");

const state = {
  categories: [],
};

const getters = {
  getCategories: () => state.categories,
};

const actions = {
  reportBug({ dispatch, state }, data) {
    return BugsTrackerRepository.postIssue(data)
      .then(() => {
        dispatch(
          "notifications/addSuccess",
          {
            message: state.$t(`message.notifications.bugs.reportSuccess`),
          },
          { root: true },
        );
      })
      .catch((error) => {
        if (error.response && error.response.status === 503) {
          dispatch(
            "notifications/addError",
            {
              message: state.$t(
                `message.notifications.bugs.serviceUnavailable`,
              ),
            },
            { root: true },
          );
        } else {
          dispatch(
            "notifications/addError",
            {
              message: state.$t(`message.notifications.bugs.reportFailure`),
            },
            { root: true },
          );
        }
      });
  },
  getCategories({ commit, dispatch, state }) {
    return BugsTrackerRepository.getCategories()
      .then((response) => {
        commit("SAVE_CATEGORIES", response.data);
        return response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 503) {
          dispatch(
            "notifications/addError",
            {
              message: state.$t(
                `message.notifications.bugs.serviceUnavailable`,
              ),
            },
            { root: true },
          );
        } else {
          dispatch(
            "notifications/addError",
            {
              message: state.$t(`message.notifications.bugs.reportFailure`),
            },
            { root: true },
          );
        }
        return [];
      });
  },
};

const mutations = {
  SAVE_CATEGORIES: (state, categories) => {
    state.categories = categories;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
